import type { MarketAccount } from '@talos/kyoko';
import { InspectorText } from './InspectorText';

interface MarketAccountDisplayProps {
  marketAccount: string;
  marketAccountsByName: Map<string, MarketAccount> | undefined;
}

export const MarketAccountDisplay = ({ marketAccount, marketAccountsByName }: MarketAccountDisplayProps) => {
  const account = marketAccountsByName?.get(String(marketAccount));
  const displayName = account?.DisplayName || account?.Name || marketAccount;
  return <InspectorText>{displayName}</InspectorText>;
};
